import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const PaymentBreakdownChart = ({ data }) => {
  const colors = [
    "#36A2EB",
    "#FF6384",
    "#FFCE56",
    "#4BC0C0",
    "#9966FF",
    "#FF9F40",
    "#C9CBCF",
    "#8BC34A",
    "#F44336",
    "#9C27B0",
    "#03A9F4",
    "#CDDC39",
    "#00BCD4",
    "#E91E63",
    "#795548",
    "#607D8B",
    "#FFC107",
    "#009688",
    "#673AB7",
    "#3F51B5",
  ];

  const chartData = {
    labels: data.map((item) => item.name),
    datasets: [
      {
        label: "Amount",
        data: data.map((item) => item.value),
        backgroundColor: data.map((_, i) => colors[i % colors.length]),
        borderWidth: 1,
      },
    ],
  };

  return <Pie data={chartData} />;
};

export default PaymentBreakdownChart;
